export enum KycStage {
	NOT_INITIATED = 'NOT_INITIATED',
	VERIFIED = 'VERIFIED',
	SUBMITTED = 'SUBMITTED',
	FAILED = 'FAILED',
}
